import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../environments/environment';
import {DocumentMetadataService} from "../../../api/service/documentMetadata.service";
import {MetadataDefinitionService} from "../../../api/service/metadataDefinition.service";
import {DocumentService} from "../../../api/service/document.service";
import {OAuthService} from 'angular-oauth2-oidc';
import {FilterDocumentMetadata} from "../../../api/model/filterDocumentMetadata";
import {FilterDocumentMetadataNumberOperationEnum} from "../../../api/model/filterDocumentMetadataNumberOperationEnum";
import {FilterDocumentMetadataTextOperationEnum} from "../../../api/model/filterDocumentMetadataTextOperationEnum";
import {FilterDocumentMetadataDateTimeOperationEnum} from "../../../api/model/filterDocumentMetadataDateTimeOperationEnum";
import {MetadataDefinition} from "../../../api/model/metadataDefinition";
import {MetadataDefinitionEnum} from "../../../api/model/metadataDefinitionEnum";
import { ValidatedMetadataResponse } from '../../../api/model/validatedMetadataResponse';
import {DocumentMetadata} from "../../../api/model/documentMetadata";
import { SharedService } from '../../service/shared.service';
import {DocumentFileMetadata} from "../../../api/model/documentFileMetadata";
import { FormGroup, FormControl, FormBuilder, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { checkDocCategoryAndDocTypeAllowedRule, checkPolicyHolderIdGreaterThan1000Rule, checkEmailCopyToIsAllowedRule,
	checkEmailSendTimestampRule, checkEmailSubjectIsAllowedRule, checkSpecialDocumentTypeIsFilledWithNoteRule,
	checkSpecialDocumentTypeWithDocTitleExistRule, checkSpecialDocumentTypeWithCountryExistRule, checkDocumentDatesValidRule,
	checkDocCategoryAndDocStatusStatusAllowRule, checkDocStatusAndJustificationRule, checkConfidentialityLevelRule,
	checkDocCategoryIsAkAndDocTypeAllowedRule, checkDocCategoryIsApgAndDocTypeAllowedRule, checkDocCategoryIsDnAndDocTypeAllowedRule,
	checkDocCategoryIsCorruptionPreventionAndDocTypeAllowedRule, checkDocCategoryIsObjectAndDocTypeAllowedRule, checkDocCategoryIsDamageAndDocTypeAllowedRule ,checkDocCategoryIsRescheduleAndDocTypeAllowedRule,
	checkDocCategoryIsEnvAssessmentAndDocTypeAllowedRule, checkDocCategoryIsContractAndDocTypeAllowedRule,
	checkDocTypesAndCategoryAllowedRule, checkDocTypeInvoiceAndHolderIdRule, checkDocTypeOverviewAndHolderIdRule, checkDocTypeSaleAndCategoryNotApgRule,
	checkDocTypeCompInfoRule, checkDocTypeNoteAndCategoryNotApgRule, checkDocCategoryIsPolicyHolderAndEncoresFlagTrueRule, checkDocCategoryIsForeignCustomerAndEncoresFlagTrueRule,
	checkEmailChangedRule, DocumentCategoryDocumentTypeMatrix, alwaysInvalid
} from '../../validator/rules';
import { checkDocCategoryAndDocTypeAllowedText, checkPolicyHolderIdGreaterThan1000Text, checkEmailRecipientText, checkSpecialDocumentTypeIsFilledWithNoteText,
	checkSpecialDocumentTypeWithDocTitleExistsText, checkSpecialDocumentTypeWithCountryExistsText, checkDocumentDateIsValidText,
	checkDocCategoryAndDocStatusAllowText, checkDocStatusAndJustificationText, checkConfidentialityLevelText,
	checkDocCategoryIsAkAndDocTypeAllowedText, checkDocCategoryIsApgAndDocTypeAllowedText, checkDocCategoryIsDnAndDocTypeAllowedText,
	checkDocCategoryIsCorruptionPreventionAndDocTypeAllowedText, checkDocCategoryIsObjectAndDocTypeAllowedText, checkDocCategoryIsDamageAndDocTypeAllowedText,
	checkDocCategoryIsRescheduleAndDocTypeAllowedText, checkDocCategoryIsEnvAssessmentAndDocTypeAllowedText, checkDocCategoryIsContractAndDocTypeAllowedText,
	checkDocTypesAndCategoryAllowedText, checkDocTypeInvoiceAndHolderIdText, checkDocTypeOverviewAndHolderIdText, checkDocTypeSaleAndCategoryNotApgText,
	checkDocTypeCompInfoText, checkDocTypeNoteAndCategoryNotApgText, checkDocCategoryIsPolicyHolderAndEncoresFlagTrueText, checkDocCategoryIsForeignCustomerAndEncoresFlagTrueText,
	coverProcessIdInvalidText, policyHolderIdInvalidText, foreignCustomerIdInvalidText, contractNumberInvalidText, checkEmailChangedText
} from '../../validator/error-messages/importErrorMessages';

@Component({
	selector: 'app-metadata-form',
	templateUrl: './metadata-form.component.html',
	styleUrls: ['./metadata-form.component.scss'],
})
export class MetadataFormComponent implements OnInit {
  WRONG_NUMERIC_MSG: string = "Es wurde ein falscher Wert (nur Zahlen/Ziffern sind erlaubt) eingegeben. Bitte die Eingabe korrigieren.";
	permanentlyDisabledFields: string[] = ['documentStatusTimestamp', 'changeUser', 'documentMimeType', 'loadDate',
		'loadTime', 'loadUser', 'documentError', 'jobId', 'dui', 's3Path', 'edmId', 'originalId'];

  @Input() set update(value: boolean) {
		if (value) {
			for (var control in this.documentMetadataForm.controls) {
			  if (!this.permanentlyDisabledFields.includes(control)) {
				  this.documentMetadataForm.controls[control].enable();
				}
			}
		} else {
		  this.updateAllowedAtStartup = false;
			for (var control in this.documentMetadataForm.controls) {
				this.documentMetadataForm.controls[control].disable();
			}
		}
	}

  @Input() documentMetadata: DocumentFileMetadata = { };
  @Input() myMap: Map<string, string> = new Map();
  @Input() showCheckbox = false;

  @Output() allValidChanged = new EventEmitter<boolean>();

  documentCategoryData: MetadataDefinition[] = [];
  documentTypeData: MetadataDefinition[] = [];
  documentTypeDataPossibilities: MetadataDefinition[] = [];
  documentStatusData: MetadataDefinition[] = [];
  confidentialityLevelData: MetadataDefinition[] = [];
  documentProcessedData: MetadataDefinition[] = [];
  dataProtectionData: MetadataDefinition[] = [];
  countriesData: MetadataDefinition[] = [];
  inOutFlagData: MetadataDefinition[] = [];
  documentChannelData: MetadataDefinition[] = [];
  deliverySystemData: MetadataDefinition[] = [];

  loader = false;
  updateAllowedAtStartup = true;

  constructor(
    private readonly documentService: DocumentService,
    private readonly documentMetadataService: DocumentMetadataService,
    private readonly oauthService: OAuthService,
    private readonly metadataDefinitionService: MetadataDefinitionService,
    private readonly sharedService: SharedService,
    private readonly fb: FormBuilder
  ) {
  	this.documentMetadataForm = this.fb.group({
  		// I have to pass initialEmail to validation rule 30, which is not present during constructor lifetime, but at ngOnInit
  		// And I still need to have this initialized so that the compiler doesn't complain
  	});
  }

  checkDocCategoryAndDocTypeAllowedText: string = checkDocCategoryAndDocTypeAllowedText;
  checkPolicyHolderIdGreaterThan1000Text: string = checkPolicyHolderIdGreaterThan1000Text;
  checkEmailRecipientText: string = checkEmailRecipientText;
  checkSpecialDocumentTypeIsFilledWithNoteText: string = checkSpecialDocumentTypeIsFilledWithNoteText;
  checkSpecialDocumentTypeWithDocTitleExistsText: string = checkSpecialDocumentTypeWithDocTitleExistsText;
  checkSpecialDocumentTypeWithCountryExistsText: string = checkSpecialDocumentTypeWithCountryExistsText;
  checkDocumentDateIsValidText: string = checkDocumentDateIsValidText;
  checkDocCategoryAndDocStatusAllowText: string = checkDocCategoryAndDocStatusAllowText;
  checkDocStatusAndJustificationText: string = checkDocStatusAndJustificationText;
  checkConfidentialityLevelText: string = checkConfidentialityLevelText;
  checkDocCategoryIsAkAndDocTypeAllowedText: string = checkDocCategoryIsAkAndDocTypeAllowedText;
  checkDocCategoryIsApgAndDocTypeAllowedText: string = checkDocCategoryIsApgAndDocTypeAllowedText;
  checkDocCategoryIsDnAndDocTypeAllowedText: string = checkDocCategoryIsDnAndDocTypeAllowedText;
  checkDocCategoryIsCorruptionPreventionAndDocTypeAllowedText: string = checkDocCategoryIsCorruptionPreventionAndDocTypeAllowedText;
  checkDocCategoryIsObjectAndDocTypeAllowedText: string = checkDocCategoryIsObjectAndDocTypeAllowedText;
  checkDocCategoryIsDamageAndDocTypeAllowedText: string = checkDocCategoryIsDamageAndDocTypeAllowedText;
  checkDocCategoryIsRescheduleAndDocTypeAllowedText: string = checkDocCategoryIsRescheduleAndDocTypeAllowedText;
  checkDocCategoryIsEnvAssessmentAndDocTypeAllowedText: string = checkDocCategoryIsEnvAssessmentAndDocTypeAllowedText;
  checkDocCategoryIsContractAndDocTypeAllowedText: string = checkDocCategoryIsContractAndDocTypeAllowedText;
  checkDocTypesAndCategoryAllowedText: string = checkDocTypesAndCategoryAllowedText;
  checkDocTypeInvoiceAndHolderIdText: string = checkDocTypeInvoiceAndHolderIdText;
  checkDocTypeOverviewAndHolderIdText: string = checkDocTypeOverviewAndHolderIdText;
  checkDocTypeSaleAndCategoryNotApgText: string = checkDocTypeSaleAndCategoryNotApgText;
  checkDocTypeCompInfoText: string = checkDocTypeCompInfoText;
  checkDocTypeNoteAndCategoryNotApgText: string = checkDocTypeNoteAndCategoryNotApgText;
  checkDocCategoryIsPolicyHolderAndEncoresFlagTrueText: string = checkDocCategoryIsPolicyHolderAndEncoresFlagTrueText;
  checkDocCategoryIsForeignCustomerAndEncoresFlagTrueText: string = checkDocCategoryIsForeignCustomerAndEncoresFlagTrueText;
  coverProcessIdInvalidText: string = coverProcessIdInvalidText;
  policyHolderIdInvalidText: string = policyHolderIdInvalidText;
  foreignCustomerIdInvalidText: string = foreignCustomerIdInvalidText;
  contractNumberInvalidText: string = contractNumberInvalidText;
  checkEmailChangedText: string = checkEmailChangedText;

  documentMetadataForm: FormGroup;

  ngOnInit(): void {
  	this.documentMetadataForm = this.fb.group({
  		coverProcessId: ['', [this.integerValidator()]],
  		policyHolderId: ['', [this.integerValidator()]],
  		foreignCustomerId: ['', [this.integerValidator()]],
  		contractNumber: ['', [this.integerValidator()]],
  		country: [''],
  		documentDate: [''],
  		documentCategory: [''],
  		documentType: [''],
  		documentTitle: [''],
  		documentProcessed: [''],
  		documentNotes: [''],
  		documentStatus: [''],
  		documentStatusTimestamp: [{
  			value: '',
  			disabled: true
  		}],
  		emailReceipt: [''],
  		emailCopyTo: [''],
  		emailSubject: [''],
  		emailSendTimestamp: [''],
  		invoiceNumber: [''],
  		inOutFlag: [''],
  		documentChannel: [''],
  		documentPagesNo: [''],
  		confidentialityLevel: ['2'],
  		dataProtection: [''],
  		barcode: [''],
  		barcodeGroup: [''],
  		paperArchiveReference: [''],
  		paperArchiveReference2: [''],
  		changeUser: [{
  			value: '',
  			disabled: true
  		}],
  		deliverySystem: [''],
  		documentMimeType: [{
  			value: '',
  			disabled: true
  		}],
  		loadDate: [{
  			value: '',
  			disabled: true
  		}],
  		loadTime: [{
  			value: '',
  			disabled: true
  		}],
  		loadUser: [{
  			value: '',
  			disabled: true
  		}],
  		documentError: [{
  			value: '',
  			disabled: true
  		}],
  		jobId: [{
  			value: '',
  			disabled: true
  		}],
  		retentionDate: [''],
  		dui: [{
  			value: '',
  			disabled: true
  		}],
  		s3Path: [{
  			value: '',
  			disabled: true
  		}],
  		edmId: [{
  			value: '',
  			disabled: true
  		}],
  		originalId: [{
  			value: '',
  			disabled: true
  		}],
  	}, {
  		validators: [checkDocCategoryAndDocTypeAllowedRule, checkPolicyHolderIdGreaterThan1000Rule, checkEmailCopyToIsAllowedRule,
  			checkEmailSendTimestampRule, checkEmailSubjectIsAllowedRule, checkSpecialDocumentTypeIsFilledWithNoteRule,
  			checkSpecialDocumentTypeWithDocTitleExistRule, checkSpecialDocumentTypeWithCountryExistRule, checkDocumentDatesValidRule,
  			checkDocCategoryAndDocStatusStatusAllowRule, checkDocStatusAndJustificationRule, checkConfidentialityLevelRule,
  			checkDocCategoryIsAkAndDocTypeAllowedRule, checkDocCategoryIsApgAndDocTypeAllowedRule, checkDocCategoryIsDnAndDocTypeAllowedRule,
  			checkDocCategoryIsCorruptionPreventionAndDocTypeAllowedRule, checkDocCategoryIsObjectAndDocTypeAllowedRule, checkDocCategoryIsDamageAndDocTypeAllowedRule,
  			checkDocCategoryIsRescheduleAndDocTypeAllowedRule, checkDocCategoryIsEnvAssessmentAndDocTypeAllowedRule, checkDocCategoryIsContractAndDocTypeAllowedRule,
  			checkDocTypesAndCategoryAllowedRule, checkDocTypeInvoiceAndHolderIdRule, checkDocTypeOverviewAndHolderIdRule, checkDocTypeSaleAndCategoryNotApgRule,
  			checkDocTypeCompInfoRule, checkDocTypeNoteAndCategoryNotApgRule, checkDocCategoryIsPolicyHolderAndEncoresFlagTrueRule, checkDocCategoryIsForeignCustomerAndEncoresFlagTrueRule,
  			checkEmailChangedRule(this.documentMetadata.emailReceipt)
  		]
  	});	

  	if (!this.updateAllowedAtStartup) {
  		for (var formControlName in this.documentMetadataForm.controls) {
  			this.documentMetadataForm.controls[formControlName].disable();
  		}
  	}	

  	this.documentMetadataForm.valueChanges.subscribe(() => {
  		let noErrors: boolean = true;
  		Object.keys(this.documentMetadataForm.controls).forEach(controlName => {
  			const control = this.documentMetadataForm.get(controlName);
  			if (control!.errors) {
  				noErrors = false;
  			}
  		});
  		this.allValidChanged.emit(noErrors && this.documentMetadataForm.errors === null);
  	});

  	this.documentMetadataService.configuration.apiKeys = {
  		Authorization: `Bearer ${this.oauthService.getAccessToken()}`
  	};
  	this.metadataDefinitionService.configuration.apiKeys = {
  		Authorization: `Bearer ${this.oauthService.getAccessToken()}`
  	};
  	this.loadDropdownData(MetadataDefinitionEnum.COUNTRY, this.countriesData);
  	this.loadDropdownData(MetadataDefinitionEnum.DOCUMENTCATEGORY, this.documentCategoryData);
  	this.loadDropdownData(MetadataDefinitionEnum.DOCUMENTTYPE, this.documentTypeData);
  	this.loadDropdownData(MetadataDefinitionEnum.DOCUMENTSTATUS, this.documentStatusData);
  	this.loadDropdownData(MetadataDefinitionEnum.DOCUMENTPROCESSED, this.documentProcessedData);
  	this.loadDropdownData(MetadataDefinitionEnum.CONFIDENTIALITYLEVEL, this.confidentialityLevelData);
  	this.loadDropdownData(MetadataDefinitionEnum.DATAPROTECTION, this.dataProtectionData);
  	this.loadDropdownData(MetadataDefinitionEnum.INOUTFLAG, this.inOutFlagData);
  	this.loadDropdownData(MetadataDefinitionEnum.DOCUMENTCHANNEL, this.documentChannelData);
  	this.loadDropdownData(MetadataDefinitionEnum.DELIVERYSYSTEM, this.deliverySystemData);
  }

  showOptions(event: any, fieldName: string) {
  	if (event.target.checked) {
  		this.myMap.set(fieldName, this.documentMetadata[fieldName]);
  	} else {
  		this.myMap.delete(fieldName);
  	}
  }

  loadDropdownData(metadataDefinitionEnum: MetadataDefinitionEnum, metadataDefinitiondData: MetadataDefinition[]) {
    metadataDefinitiondData.push({key: '', value: ''});	
	try{
  	this.metadataDefinitionService.metadatadefinitionGet(metadataDefinitionEnum).subscribe((data: MetadataDefinition[]) => {
  		data.forEach((item: MetadataDefinition) => {
   	    for (const [key, value] of Object.entries(item)) {
  				metadataDefinitiondData.push({key: key, value: value});
  			}
  		});
  	});
	}catch (error) {
	  console.error('Error loading metadata definitions:', error);
	}
  }

  dependenciesForDocumentCategoryAndDocumentType(documentCategory: any) {
  	const documentTypePossibilities = DocumentCategoryDocumentTypeMatrix.getDocumentTypePossibilities(documentCategory);
  	if (documentTypePossibilities) {
  		this.filterDocumentType(documentTypePossibilities);
  	}
  }

  filterDocumentType(documentTypePossibilities: string[]) {
  	this.documentTypeDataPossibilities = [];
  	Object.entries(this.documentTypeData).forEach(([_index, value]) => {
  		if (value && value.key && documentTypePossibilities.includes(value.key)) {
  			this.documentTypeDataPossibilities.push(value);
  		}
  	});
  }

  validateWithEncores() {
  	let formData: any = this.buildFormData();
  	this.loader = true;
  	const formDataJson = this.getFormDataAsJson(formData);
  	this.documentService.validateMetadata(formDataJson).subscribe(
  		(response: ValidatedMetadataResponse) => {
			if (response.countryPerson) {
  			  this.documentMetadata.country = response.fullresult!.country_person!.country_egd;
  			  this.documentMetadataForm.removeControl('foreignCustomerIdInvalid');
  			}

			if (response.coverValid) {
  				this.documentMetadata.policyHolderId = response.fullresult!.cover!.person_dn;
  				this.documentMetadata.foreignCustomerId = response.fullresult!.cover!.person_ak;
  				this.documentMetadata.country = response.fullresult!.cover!.country_egd;
  				this.documentMetadataForm.removeControl('coverProcessIdInvalid');
  			}  			

  			if (response.contractApgNewValid) {
  			  this.documentMetadata.policyHolderId = response.fullresult!.apg!.person_dn;
  			  this.documentMetadataForm.removeControl('contractNumberInvalid');
  			}

  			if (response.coverValid === null) {
  				this.documentMetadataForm.removeControl('coverProcessIdInvalid');
  			}

  			if (response.countryPerson === null) {
  				this.documentMetadataForm.removeControl('foreignCustomerIdInvalid');
  			}

  			if (response.contractApgNewValid === null) {
  				this.documentMetadataForm.removeControl('contractNumberInvalid');
  			}

  			if (response.personDnValid || response.personDnValid === null) {
  				this.documentMetadataForm.removeControl('policyHolderIdInvalid');
  			}

  			if (response.coverValid === false) {
  				const control = this.fb.control('', alwaysInvalid());
  				this.documentMetadataForm.addControl('coverProcessIdInvalid', control);
  			}

  			if (response.contractApgNewValid === false) {
  				const control = this.fb.control('', alwaysInvalid());
  				this.documentMetadataForm.addControl('contractNumberInvalid', control);
  			}

  			if (response.personDnValid === false) {
  				const control = this.fb.control('', alwaysInvalid());
  				this.documentMetadataForm.addControl('policyHolderIdInvalid', control);
  			}

			  if (response.countryPerson === false) {
  				const control = this.fb.control('', alwaysInvalid());
  				this.documentMetadataForm.addControl('foreignCustomerIdInvalid', control);
  			}

  			this.loader = false;
  		},
  		() => this.loader = false
  	);
  }

  buildFormData(): FormData {
  	let formData: any = new FormData();
  	Object.entries(this.documentMetadata).forEach(([key, value]) => {
  		if (!!value) {
  			if (key === 'file'){
  				formData.append("documentMimeType", value[0].file.type);
  				formData.append("fileName", value[0].file.name);
  				formData.append(key, value[0].file);
  			} else {
  				formData.append(key, value);
  			}
  		}
  	});
  	return formData;
  }

  getFormDataAsJson(formData: FormData) {
  	const jsonObject: { [key: string]: any } = {};
  	formData.forEach((value: any, key: string) => {
  		jsonObject[key] = value;
  	});
  	return JSON.stringify(jsonObject);
  }

  integerValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const integerPattern = /^-?\d+$/;
      const isValid = integerPattern.test(control.value);
      return isValid ? null : { 'notInteger': { value: control.value } };
    };
  }
}
